var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payouts-status-container"},[(_vm.sw_status==='')?_c('div',{staticClass:"payouts-status",class:_vm.getClass},[_vm._v(" "+_vm._s(_vm.status)+" ")]):_vm._e(),(_vm.sw_status)?_c('div',{staticClass:"payouts-status",class:_vm.getClassReceived},[_vm._v(" "+_vm._s(_vm.sw_status)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }